// components/menu/ItemList.jsx
import React from "react";

const row = (active, hidden) => ({
  padding: "8px 10px",
  borderRadius: 8,
  border: active
    ? "2px solid #3b82f6"      // blue outline for selected
    : "1px solid #e5e5e5",
  background: active ? "#eef8ff" : "#fff",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  opacity: hidden ? 0.45 : 1,
  cursor: "pointer",
});

const badge = {
  fontSize: 10,
  padding: "2px 6px",
  borderRadius: 999,
  background: "#eee",
  color: "#666",
  marginLeft: 8,
  border: "1px solid #ddd",
};

export default function ItemList({
  items = [],
  code,
  selectedItemId,
  onSelect,     // <── NEW: MenuManager will set selectedItemId
  onOpen,       // <── NEW: double-click opens
  onEdit,       // existing behavior (click / edit btn)
  showPath = false,
  emptyMessage = "No items.",
}) {
  const isHidden = (it) =>
    String(it?.visibility ?? it?.raw?.visibility ?? it?.visible ?? "1") === "0";

  return (
    <div
      className="menu-manager-list"
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 8,
        maxHeight: "75vh",
        overflowY: "auto",
      }}
    >
      {items.map((it) => {
        const active = String(it.id) === String(selectedItemId);
        const hidden = isHidden(it);
        const allergenNames = (it.allergens_resolved || [])
          .map((a) => a.title)
          .filter(Boolean);
        const allergenLabel =
          allergenNames.length
            ? allergenNames.join(", ")
            : (it.allergens?.titles || []).join(", ");

        return (
          <div
            key={it.id}
            style={row(active, hidden)}
            onClick={() => onSelect?.(it)}                          
            onDoubleClick={() => onOpen?.(it, code)}                
          >
            {/* LEFT content - but stop click from opening edit immediately */}
            <div
              onClick={(e) => {
                e.stopPropagation();      // prevent row click
                onEdit?.(it, code);       // supports existing behavior
              }}
              style={{ cursor: "pointer" }}
            >
              <div
                style={{
                  fontWeight: 600,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {it.name || it.item}
                {hidden && <span style={badge}>Hidden</span>}
              </div>

              {showPath && it.parentPath ? (
                <div style={{ fontSize: 11, color: "#888", marginTop: 2 }}>
                  {it.parentPath}
                </div>
              ) : null}

              <div style={{ fontSize: 12, color: "#666" }}>
                P{Number(it.price ?? 0).toFixed(2)} •{" "}
                {hidden ? "Hidden From App Menu" : "Visible In App Menu"}
                {allergenLabel ? ` • ${allergenLabel}` : ""}
              </div>
            </div>

            {/* EDIT button */}
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();   // prevent row click selecting before edit
                onEdit?.(it, code);
              }}
              style={{
                padding: "4px 8px",
                borderRadius: 8,
                fontSize: "12px",
                border: "1px solid rgba(255, 0, 0, 1)",
                background: "rgba(255, 0, 0, 1)",
                color: "#fff",
              }}
            >
              Edit
            </button>
          </div>
        );
      })}

      {items.length === 0 && (
        <div style={{ color: "#777", fontSize: 12 }}>{emptyMessage}</div>
      )}
    </div>
  );
}
